import { render } from "./UnitSelector.vue?vue&type=template&id=5f574f8d&scoped=true"
import script from "./UnitSelector.vue?vue&type=script&lang=js"
export * from "./UnitSelector.vue?vue&type=script&lang=js"

import "./UnitSelector.vue?vue&type=style&index=0&id=5f574f8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f574f8d"]])

export default __exports__